import React from 'react';
import ListLayout from '@presentation/layouts/ListLayout';
import Creator from '@presentation/pages/Creator';
import type { CreatorModel } from '@domain/models';

import { makeCreatorsService } from '../makeCreatorService';

const makeCreator = (creator: CreatorModel, firstPage: any, intro?: string) => {
	const creatorsService = makeCreatorsService();

	return (
		<ListLayout>
			<Creator creator={creator} firstPage={firstPage} creatorsService={creatorsService} intro={intro} />
		</ListLayout>
	);
};

export default makeCreator;
